module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8MUVw"))).then(() => parcelRequire('1iHdE'));